<div class="fc-ag-context-menu" [ngClass]="[options.contextClass ? options.contextClass : '']">
    <div class="fc-ag-context-menu-wrapper">
        <div class="fc-ag-context-menu-list">
            <div *ngFor="let menu of options.menus">
                <div class="fc-ag-context-menu-item"
                     fcTooltip [fcTooltipContent]="menu.tooltip || ''"
                     [fcTooltipPosition]="menu.tooltipPosition || 'pointer'"
                     [tooltipClass]="menu.tooltipClass || ''"
                     [ngClass]="[
                        menu.class ? menu.class : '',
                        menu.isDisabled && menu.isDisabled(menu) ? 'disabled' : '' 
                    ]"
                     *ngIf="!(options.isContextMenuHidden && options.isContextMenuHidden(menu))"
                     (click)="options.onContextMenuClick && options.onContextMenuClick(menu); close()">
                    <div class="fc-ag-context-menu-item-content" [innerHTML]="renderMenuItem(menu)"></div>
                </div>
            </div>
        </div>
    </div>
</div>
